module.exports = __webpack_public_path__ + "img/chevron-left.3c7f6a26.svg";